import { applyReducers } from '@va/dashboard/reducers';
import { calculateDiscount } from '@va/util/helpers';
import { packageId, wixDefaultSubscriptionPricePerMonth } from '@va/wix/shared/constants';
import { getWixHigherPackPrices } from '@va/wix/shared/helpers';
import getSymbolFromCurrency from 'currency-symbol-map';
import Immutable from 'immutable';
import * as Types from 'wix/actions/types';

export default (
  state = Immutable.fromJS({
    premiumPlan: {
      [packageId.BASIC]: {
        id: packageId.BASIC,
        currencyCode: 'USD',
        currencySymbol: '$',
        monthlyPrice: wixDefaultSubscriptionPricePerMonth[packageId.BASIC].MONTHLY,
        monthlyUpgradeUrl: '#',
        yearlyPrice: wixDefaultSubscriptionPricePerMonth[packageId.BASIC].YEARLY,
        yearlyUpgradeUrl: '#',
        discountPercent: calculateDiscount(
          wixDefaultSubscriptionPricePerMonth[packageId.BASIC].MONTHLY,
          wixDefaultSubscriptionPricePerMonth[packageId.BASIC].YEARLY,
        ),
      },
      [packageId.ADVANCED]: {
        id: packageId.ADVANCED,
        currencyCode: 'USD',
        currencySymbol: '$',
        monthlyPrice: wixDefaultSubscriptionPricePerMonth[packageId.ADVANCED].MONTHLY,
        monthlyUpgradeUrl: '#',
        yearlyPrice: wixDefaultSubscriptionPricePerMonth[packageId.ADVANCED].YEARLY,
        yearlyUpgradeUrl: '#',
        discountPercent: calculateDiscount(
          wixDefaultSubscriptionPricePerMonth[packageId.ADVANCED].MONTHLY,
          wixDefaultSubscriptionPricePerMonth[packageId.ADVANCED].YEARLY,
        ),
      },
      [packageId.PRO]: {
        id: packageId.PRO,
        currencyCode: 'USD',
        currencySymbol: '$',
        monthlyPrice: wixDefaultSubscriptionPricePerMonth[packageId.PRO].MONTHLY,
        monthlyUpgradeUrl: '#',
        yearlyPrice: wixDefaultSubscriptionPricePerMonth[packageId.PRO].YEARLY,
        yearlyUpgradeUrl: '#',
        discountPercent: calculateDiscount(
          wixDefaultSubscriptionPricePerMonth[packageId.PRO].MONTHLY,
          wixDefaultSubscriptionPricePerMonth[packageId.PRO].YEARLY,
        ),
      },
    },
  }),
  action,
) => {
  switch (action.type) {
    case Types.wix.App.MIGRATION_EMAIL_SENT:
      return state.set('isMigrationEmailSent', action.data);
    case Types.wix.App.SAVE_PREMIUM_PLAN_SUCCEEDED: {
      const package1 = action.data.packages && action.data.packages.find((item) => item.id === packageId.BASIC);
      const package2 = action.data.packages && action.data.packages.find((item) => item.id === packageId.ADVANCED);
      const package3 = action.data.packages && action.data.packages.find((item) => item.id === packageId.PRO);
      if (package1) {
        const yearlyPricePackage1 = package1.yearly.price;
        state = state
          .setIn(['premiumPlan', packageId.BASIC, 'id'], package1.id)
          .setIn(['premiumPlan', packageId.BASIC, 'currencyCode'], package1.currencyCode)
          .setIn(['premiumPlan', packageId.BASIC, 'currencySymbol'], getSymbolFromCurrency(package1.currencyCode))
          .setIn(['premiumPlan', packageId.BASIC, 'monthlyPrice'], package1.monthly.price)
          .setIn(['premiumPlan', packageId.BASIC, 'monthlyUpgradeUrl'], package1.monthly.url)
          .setIn(['premiumPlan', packageId.BASIC, 'yearlyPrice'], yearlyPricePackage1)
          .setIn(['premiumPlan', packageId.BASIC, 'yearlyUpgradeUrl'], package1.yearly.url)
          .setIn(
            ['premiumPlan', packageId.BASIC, 'discountPercent'],
            calculateDiscount(package1.monthly.price, yearlyPricePackage1),
          );

        state = updatePlanDetailsFromWixSdk(state, packageId.ADVANCED, package2, package1);
        state = updatePlanDetailsFromWixSdk(state, packageId.PRO, package3, package2);
      }
      return state;
    }
    case Types.wix.App.SET_INITIAL_UPGRADE_PLAN_ID:
      return state.set('initialUpgradePlanId', action.data);
    case Types.wix.App.SET_INITIAL_ONBOARDING_STEP:
      return state.set('initialOnboardingStep', action.data);
    case Types.wix.App.SET_INITIAL_UPGRADE_PLAN_SUBSCRIPTION_TYPE:
      return state.set('initialUpgradePlanSubscriptionType', action.data);
    default:
      return applyReducers(state, action, {});
  }
};

function updatePlanDetailsFromWixSdk(state, currentPackageId, currentPackage, previousPackage) {
  if (currentPackage) {
    const currentPackageYearlyPrice = currentPackage.yearly.price;
    state = state
      .setIn(['premiumPlan', currentPackageId, 'id'], currentPackage.id)
      .setIn(['premiumPlan', currentPackageId, 'currencyCode'], currentPackage.currencyCode)
      .setIn(['premiumPlan', currentPackageId, 'currencySymbol'], getSymbolFromCurrency(currentPackage.currencyCode))
      .setIn(['premiumPlan', currentPackageId, 'monthlyPrice'], currentPackage.monthly.price)
      .setIn(['premiumPlan', currentPackageId, 'monthlyUpgradeUrl'], currentPackage.monthly.url)
      .setIn(['premiumPlan', currentPackageId, 'yearlyPrice'], currentPackageYearlyPrice)
      .setIn(['premiumPlan', currentPackageId, 'yearlyUpgradeUrl'], currentPackage.yearly.url)
      .setIn(
        ['premiumPlan', currentPackageId, 'discountPercent'],
        calculateDiscount(currentPackage.monthly.price, currentPackageYearlyPrice),
      );
  } else {
    // Update currency code + prices based on previous package from SDK
    const { MONTHLY, YEARLY } = getWixHigherPackPrices(previousPackage.monthly.price);
    const currentPackageYearlyPrice = YEARLY;
    state = state
      .setIn(['premiumPlan', currentPackageId, 'currencyCode'], previousPackage.currencyCode)
      .setIn(['premiumPlan', currentPackageId, 'currencySymbol'], getSymbolFromCurrency(previousPackage.currencyCode))
      .setIn(['premiumPlan', currentPackageId, 'monthlyPrice'], MONTHLY)
      .setIn(['premiumPlan', currentPackageId, 'yearlyPrice'], currentPackageYearlyPrice)
      .setIn(
        ['premiumPlan', currentPackageId, 'discountPercent'],
        calculateDiscount(MONTHLY, currentPackageYearlyPrice),
      );
  }
  return state;
}
